<template>
  <div class="support">
    <div class="support-content">
      <div class="support-title">
        <div class="left">
          <div class="title-56">{{ $t('keypalTwo.support.title') }}</div>
          <div class="desc-18">
            Bitcoin, Ethereum, USDT, USDC, BNB, TRX, SOL
            {{ $t('common.more') }}
          </div>
        </div>
        <div class="right">
          <div class="button" @click="onSupport">
            <span>{{ $t('keypalTwo.support.desc_1') }}</span>
          </div>
        </div>
      </div>
      <div class="scroll-wrap">
        <div
          class="swiper-list"
          ref="scrollElement"
          :class="{ paused: isPaused }"
        >
          <div
            class="scroll-item"
            v-for="(item, index) in supportList"
            :key="index"
            @mouseenter="onMouseEnter(true)"
            @mouseleave="onMouseLeave(false)"
          >
            <img :src="item.icon" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="other-content">
      <div class="title-56">{{ $t('keypalTwo.other.title') }}</div>
      <div class="other-list hidden-scrollbar">
        <div
          class="other-item ani-scale"
          v-for="(item, index) in otherList"
          :key="index"
          @click="onUrl(item)"
        >
          <div class="item-title">{{ item.label }}</div>
          <div class="item-desc text-ellipsis-more">{{ item.desc }}</div>
          <div class="item-button">
            <span>{{ $t('common.learnMore') }}</span>
            <img :src="enterImg" alt="" />
          </div>
          <div class="other-img-wrap">
            <img :class="[item.class]" :src="item.icon" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isPaused: false,
    };
  },

  computed: {
    supportList() {
      let list = [
        {
          icon: require(`../../assets/images/keypal-two/chain-icon/01.png`),
        },
        {
          icon: require(`../../assets/images/keypal-two/chain-icon/02.png`),
        },
        {
          icon: require(`../../assets/images/keypal-two/chain-icon/03.png`),
        },
        {
          icon: require(`../../assets/images/keypal-two/chain-icon/04.png`),
        },
        {
          icon: require(`../../assets/images/keypal-two/chain-icon/05.png`),
        },
        {
          icon: require(`../../assets/images/keypal-two/chain-icon/06.png`),
        },
        {
          icon: require(`../../assets/images/keypal-two/chain-icon/07.png`),
        },
        {
          icon: require(`../../assets/images/keypal-two/chain-icon/08.png`),
        },
        {
          icon: require(`../../assets/images/keypal-two/chain-icon/09.png`),
        },
        {
          icon: require(`../../assets/images/keypal-two/chain-icon/10.png`),
        },
        {
          icon: require(`../../assets/images/keypal-two/chain-icon/11.png`),
        },
        {
          icon: require(`../../assets/images/keypal-two/chain-icon/12.png`),
        },
        {
          icon: require(`../../assets/images/keypal-two/chain-icon/13.png`),
        },
        {
          icon: require(`../../assets/images/keypal-two/chain-icon/14.png`),
        },
      ];
      return [...list, ...list];
    },

    otherList() {
      return [
        {
          label: 'KeyPal Plus',
          desc: this.$t('keypalTwo.other.desc_1'),
          class: 'other-img-1',
          icon: require(`../../assets/images/keypal-two/KeyPal-Plus.png`),
          // routePath: '/keypalplus',
          url: location.origin + '/#/keypalplus',
        },
        {
          label: 'KeyPal Card',
          desc: this.$t('keypalTwo.other.desc_2'),
          class: 'other-img-2',
          icon: require(`../../assets/images/keypal-two/KeyPal-Card.png`),
          url: `https://card.keypal.pro/`,
        },
        {
          label: this.$t('common.secretBox'),
          desc: this.$t('keypalTwo.other.desc_3'),
          class: 'other-img-3',
          icon: require(`../../assets/images/keypal-two/Secret-Box.png`),
          // routePath: '/safebox',
          url: location.origin + '/#/safebox',
        },
      ];
    },

    enterImg() {
      return require(`../../assets/images/keypal-two/arrow-enter.png`);
    },
  },
  mounted() {
    this.setupAnimation();
  },
  beforeDestroy() {
    if (this.scrollInterval) {
      clearInterval(this.scrollInterval);
    }
  },
  methods: {
    onUrl(item) {
      if (item.url) {
        window.open(item.url, '_blank');
        return;
      }
      this.$router.push({ path: item.routePath });
    },
    onSupport() {
      window.open(location.origin + '/#/blockchain', '_blank');
      // this.$router.push({ path: '/blockchain' });
    },
    onMouseEnter(flag) {
      // this.isPaused = flag;
    },
    onMouseLeave(flag) {
      this.isPaused = flag;
    },
    setupAnimation() {
      // const scrollElement = this.$el.querySelector(".swiper-list");
      this.$nextTick(() => {
        const scrollElement = this.$refs.scrollElement;
        if (scrollElement && scrollElement.scrollWidth > 0) {
          // console.log('scrollElement', this.$refs);
          // console.log('scrollWidth', scrollElement.scrollWidth);
          const duration = scrollElement.scrollWidth / 100; // 控制滚动速度
          const scrollWidth = scrollElement.scrollWidth / 2; // 单组内容宽度
          const style = document.createElement('style');
          style.innerHTML = `
            @keyframes scroll-animation {
              0% { transform: translateX(0); }
              100% { transform: translateX(-${scrollWidth}px); }
            }
            .swiper-list {
              animation: scroll-animation ${duration}s linear infinite;
              animation-play-state: running; /* 默认运行 */
            }
            .swiper-list.paused {
              animation-play-state: paused; /* 暂停状态 */
            }
          `;
          document.head.appendChild(style);
        } else {
          setTimeout(() => {
            this.setupAnimation();
          }, 100);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.support {
  background: var(--bg-1);
  .support-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 172px 0 0;

    .support-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 0 20px;

      .left {
        .title-56 {
          text-align: left;
        }

        .desc-18 {
          margin-top: 30px;
          text-align: left;
        }
      }

      .right {
        white-space: nowrap;
        .button {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 32px;
          height: 60px;
          border: 2px solid var(--border-2);
          border-radius: 41px;
          font-size: 16px;
          color: var(--color-1);
          cursor: pointer;
        }
      }
    }

    .scroll-wrap {
      margin-top: 60px;
      overflow: hidden;
      position: relative;

      .swiper-list {
        display: flex;

        .scroll-item {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 32px;

          img {
            width: 80px;
            height: 80px;
          }
        }
      }
    }
  }

  .other-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 136px 0 20px;

    .title-56 {
      text-align: left;
    }

    .other-list {
      overflow: auto;
      margin-top: 43px;
      display: flex;
      gap: 16px;

      .other-item {
        flex: 1;
        background: var(--bg-5);
        border-radius: 32px;
        padding: 32px;
        text-align: center;
        cursor: pointer;

        .item-title {
          font-size: 26px;
          color: var(--color-1);
          font-weight: 600;
          text-align: left;
        }

        .item-desc {
          margin-top: 10px;
          font-size: 16px;
          color: var(--color-3);
          text-align: left;
          line-height: 20px;
        }

        .item-button {
          margin-top: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          height: 45px;
          line-height: 45px;
          background: #ffffff;
          border-radius: 31px;
          text-align: center;
          width: fit-content;
          padding: 0 24px;

          span {
            font-size: 14px;
            color: #000000;
            cursor: pointer;
          }

          img {
            width: 16px;
            height: 16px;
          }
        }

        .other-img-wrap {
          height: 340px;
          display: flex;
          align-items: center;
          justify-content: center;

          .other-img-1 {
            width: 132px;
            height: 216px;
          }

          .other-img-2 {
            width: 246px;
            height: 156px;
          }

          .other-img-3 {
            width: 267px;
            height: 156px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .support {
    .support-content {
      padding: 100px 20px 0;
    }

    .other-content {
      padding: 100px 20px 0;
    }
  }
}

@media screen and (max-width: 767px) {
  .support {
    .support-content {
      padding: 47px 0 0;
      .support-title {
        padding: 0 28px;
        flex-direction: column;
        align-items: flex-start;
        .left {
          .desc-18 {
            margin-top: 17px;
          }
        }
        .right {
          margin-top: 16px;
          .button {
            height: 41px;
            padding: 0 16px;
            font-size: 14px;
            border: 1px solid var(--border-2);
          }
        }
      }

      .scroll-wrap {
        margin: 28px 28px 0;

        .swiper-list {
          .scroll-item {
            padding: 0 16px;
            img {
              width: 40px;
              height: 40px;
            }
          }
        }
      }
    }

    .other-content {
      padding: 65px 0 90px;
      .title-56 {
        padding: 0 28px;
      }
      .other-list {
        margin-top: 20px;
        padding: 0 28px;
        .other-item {
          width: 292px;
          min-width: 292px;
          padding: 24px;

          .item-title {
            font-size: 20px;
          }
          .item-desc {
            margin-top: 4px;
            font-size: 13px;
          }
          .item-button {
            margin-top: 12px;
            height: 37px;
            line-height: 37px;
            padding: 0 20px;

            span {
              font-size: 14px;
            }

            img {
              width: 14px;
              height: 14px;
            }
          }

          .other-img-wrap {
            height: 276px;
            display: flex;
            align-items: center;
            justify-content: center;

            .other-img-1 {
              width: 132px;
              height: 216px;
            }

            .other-img-2 {
              width: 100%;
              height: auto;
            }

            .other-img-3 {
              width: 100%;
              height: auto;
            }
          }
        }
      }
    }
  }
}
</style>
